import { Component, EventEmitter, Input, Output } from '@angular/core';
import { faTimes } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-multi-select',
  templateUrl: './multi-select.component.html'
})
export class MultiSelectComponent {
  @Input() label: string = '';
  @Input() options: readonly any[] = [];
  @Input() selectedItems: any[] = [];

  // Optional: Used if the options are objects instead of simple strings
  @Input() displayKey: string = '';
  @Input() valueKey: string = '';
  @Input() tooltipKey: string = '';

  @Output() selectedItemsChange = new EventEmitter<any[]>();

  removeIcon = faTimes;
  tagActiveMap: Map<any, boolean> = new Map<any, boolean>();

  onChange(event: Event, selectElement: HTMLSelectElement) {
    const value = selectElement.value;
    if (!value || value === 'null') return;

    // Find the option based on the stringified item value
    const selectedOption = this.options.find(opt => String(this.getItemValue(opt)) === value);

    if (selectedOption) {
      const itemValue = this.getItemValue(selectedOption);

      if (!this.selectedItems) {
        this.selectedItems = [];
      }

      if (!this.selectedItems.includes(itemValue)) {
        this.selectedItems.push(itemValue);
        this.selectedItemsChange.emit(this.selectedItems);
      }
    }

    // Reset the dropdown back to the blank option
    selectElement.value = 'null';
  }

  removeItem(itemValue: any, event: Event) {
    event.preventDefault();
    const index = this.selectedItems.indexOf(itemValue);
    if (index >= 0) {
      this.selectedItems.splice(index, 1);
      this.selectedItemsChange.emit(this.selectedItems);
      this.tagActiveMap.delete(itemValue);
    }
  }

  getDisplayValue(option: any): string {
    if (!option) return '';
    return this.displayKey ? option[this.displayKey] : option;
  }

  getItemValue(option: any): any {
    if (!option) return null;
    return this.valueKey ? option[this.valueKey] : option;
  }

  getTooltipValue(option: any): string {
    if (!option || !this.tooltipKey) return '';
    return option[this.tooltipKey] || '';
  }

  getDisplayValueFromItemValue(itemValue: any): string {
    const option = this.options?.find(opt => this.getItemValue(opt) === itemValue);
    return option ? this.getDisplayValue(option) : itemValue;
  }

  setTagActiveMapValue(itemValue: any, value: boolean) {
    this.tagActiveMap.set(itemValue, value);
  }

  isTagActive(itemValue: any): boolean {
    return this.tagActiveMap.get(itemValue) || false;
  }
}
